export default __webpack_public_path__ + "static-front/media/PencilIcon.e6f55f79.svg";